import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  statusCode: number
}

const PermissionsBanner = ({ statusCode }: Props) => {
  if (statusCode === 200) return null

  const backgroundColor = 'radicalRed100'
  const icon = 'alert-circle-line'
  const noPermissions = statusCode !== 200 && !isNaN(statusCode)

  const description = () => {
    if (statusCode === 403) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_permissions'
      )
    } else {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.other_errors'
      )
    }
  }

  return (
    <>
      {noPermissions && (
        <Box
          flexDirection="column"
          justifyContent="flexStart"
          padding="s24"
          borderRadius={{ all: 'abs016' }}
          background={backgroundColor}
          gap="s8"
        >
          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Icon.Medium icon={icon} color="radicalRed1000" />
            <Text size="200" weight="bold">
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.title'
              )}
            </Text>
          </Box>

          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Text size="200">{description()}</Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default PermissionsBanner
